// On browser ready (ready but images (etc) might still be downloading)
$(document).ready(function() {
  'use strict';
  
});

// On browser load (everytihing has downloaded and is ready have loaded)
$(window).on('load', function() {
  'use strict';
    
  // Load ACF Google Maps (need to do this after everything has loaded)
  if($('.acf-map').length) {

    //Load Google Maps API
    _90d_acf_google_map.loadGoogleMapsApi();
    // then
    $(window).bind("google_map_api_ready", function(){
      $('.acf-map').each(function() {
        _90d_acf_google_map.render_map($(this));
      });
    });
  }

});
